import Element from '../components/Element';
import Feedback from '../feedback/Feedback';
import getSymbol from '../style';
import Util from '../utils/util';

/**
 * 地图工具类
 */
export default class Tool extends Element {
    /**
     * 构造方法
     * @param {object} options 可选项
     */
    constructor(options = {}) {
        super({
            priority: 0, // 优先级
            mutex: true, // 是否是排他的
            minZoom: undefined,
            maxZoom: undefined,
            ...options
        });

        this._mouseEvent = null; // 鼠标事件
        this._keyboardEvent = null; // 鼠标事件
    }

    /**
     * 添加到地图中
     * @param {Object}  map 地图对象
     */
    addTo(map) {
        if (map && map.ToolController) {
            return super.addTo(map.ToolController);
        }
        return null;
    }

    /**
     * 添加到控制器时调用，执行数据的初始化
     * @param {object} controller 控制器实例
     */
    onAdd(controller) {
        super.onAdd(controller);

        this._map = controller.map;

        if (!this.options.minZoom) {
            this.options.minZoom = this._map.getMinZoom();
        }
        if (!this.options.maxZoom) {
            this.options.maxZoom = this._map.getMaxZoom();
        }

        this.installFeedback();
        this.installSnapActor();

        this.bindEvent(this._map);
    }

    /**
     * 从控制器中删除时调用，执行数据清理
     */
    onRemove() {
        this._map.dragging.enable();
        this._map.keyboard.enable();
        this.unbindEvent(this._map);

        this.uninstallFeedback();
        this.uninstallSnapActor();

        this._map = null;

        super.onRemove();
    }

    /**
     * 绑定操作事件
     * 子类进行重写
     * @param {object} map 地图实例
     */
    bindEvent(map) {
        // map.on('click', this.onClick, this);
        // map.on('dblclick', this.onDblclick, this);
        // map.on('mousedown', this.onMouseDown, this);
        // map.on('mousemove', this.onMouseMove, this);
        // map.on('mouseup', this.onMouseUp, this);
        // map.on('keypress', this.onKeyPress, this);
        // map.on('keydown', this.onKeyDown, this);
        // map.on('keyup', this.onKeyUp, this);
        // map.on('contextmenu', this.onContextMenu, this);
    }

    /**
     * 解绑操作事件
     * 子类进行重写
     * @param {object} map 地图实例
     */
    unbindEvent(map) {
        // map.off('click', this.onClick, this);
        // map.off('dblclick', this.onDblclick, this);
        // map.off('mousedown', this.onMouseDown, this);
        // map.off('mousemove', this.onMouseMove, this);
        // map.off('mouseup', this.onMouseUp, this);
        // map.off('keypress', this.onKeyPress, this);
        // map.off('keydown', this.onKeyDown, this);
        // map.off('keyup', this.onKeyUp, this);
        // map.off('contextmenu', this.onContextMenu, this);
    }

    /**
     * 是否是排他的
     */
    isMutex() {
        return this.options.mutex;
    }

    /**
     * 检测是否启用，如果未启用则抛出错误，以停止后续的操作
     */
    checkEnabled() {
        if (!this._map) {
            throw new Error(`${this.constructor.name}未绑定到地图`);
        }

        if (!this.enabled()) {
            throw new Error(`${this.constructor.name}未启用`);
        }

        const zoom = this._map.getZoom();
        if (zoom < this.options.minZoom || zoom > this.options.maxZoom) {
            throw new Error(`${this.constructor.name}当前级别下不可用，minZoom: ${this.options.minZoom}，maxZoom:${this.options.maxZoom}，zoom:${zoom}`);
        }
    }

    /**
     * 禁用地图默认的鼠标拖动事件
     */
    disableMapDraging() {
        this._originMapDraging = this._map.dragging.enabled();
        if (this._originMapDraging) {
            this._map.dragging.disable();
        }
    }

    /**
     * 启用地图默认的鼠标拖动事件
     */
    restoreMapDraging() {
        // 属性存在并且是true
        if (this._originMapDraging === true) {
            this._map.dragging.enable();
        }
    }

    installFeedback() {
        this._feedback = new Feedback(); // 用于主要操作对象的绘制
        // 用于跟随鼠标移动的提示信息的绘制
        this._mouseInfoFeedback = new Feedback({
            priority: 99
        });
        // 用于在地图中心位置显示的提示信息的绘制
        this._centerInfoFeedback = new Feedback({
            priority: 100
        });

        this._feedbackController = this._map.FeedbackController;
        this._feedbackController.add(this._feedback);
        this._feedbackController.add(this._mouseInfoFeedback);
        this._feedbackController.add(this._centerInfoFeedback);
    }

    uninstallFeedback() {
        this._feedback.clear();
        this._mouseInfoFeedback.clear();
        this._centerInfoFeedback.clear();
        this._feedbackController.delete(this._feedback);
        this._feedbackController.delete(this._mouseInfoFeedback);
        this._feedbackController.delete(this._centerInfoFeedback);
        this._feedbackController.refresh();
        this._feedback = null;
        this._mouseInfoFeedback = null;
        this._centerInfoFeedback = null;
        this._feedbackController = null;
    }

    installSnapActor() {
        this._snapController = this._map.SnapController;
    }

    uninstallSnapActor() {
        this._snapController.clear();

        this._snapController = null;
    }

    refreshFeedback() {
        this.resetFeedback();

        this._feedbackController.refresh();
    }

    resetFeedback() {
        this._feedback.clear();
    }

    refreshSnapActor() {
        this._snapController.clear();

        this.resetSnapActor();
    }

    resetSnapActor() {}

    resetMouseInfo(text, type = 'info') {
        this._mouseInfoFeedback.clear();
        if (text) {
            let symbol = getSymbol(`mouse_msg_${type}`);
            symbol = Util.clone(symbol);
            symbol.text = text;
            const latlng = this._mouseEvent.latlng;
            this._mouseInfoFeedback.addItems({
                symbol,
                geometry: {
                    type: 'Point',
                    coordinates: [latlng.lng, latlng.lat]
                }
            });
        }
    }

    refreshMouseInfo(text, type = 'info', duration = 0) {
        // 处理duration后，tool已经被销毁的情况
        if (!this._mouseInfoFeedback || !this._feedbackController) {
            return;
        }

        this.resetMouseInfo(text, type);

        this._feedbackController.refresh();

        if (duration) {
            setTimeout(() => {
                this.refreshMouseInfo(); // 清空
            }, duration);
        }
    }

    resetCenterInfo(text, type = 'info') {
        this._centerInfoFeedback.clear();
        if (text) {
            let symbol = getSymbol(`center_msg_${type}`);
            symbol = Util.clone(symbol);
            symbol.text = text;
            const latlng = this._map.getCenter();
            this._centerInfoFeedback.addItems({
                symbol,
                geometry: {
                    type: 'Point',
                    coordinates: [latlng.lng, latlng.lat]
                }
            });
        }
    }

    refreshCenterInfo(text, type = 'info', duration = 5000) {
        // 处理duration后，tool已经被销毁的情况
        if (!this._centerInfoFeedback || !this._feedbackController) {
            return;
        }

        this.resetCenterInfo(text, type);

        this._feedbackController.refresh();

        if (duration) {
            setTimeout(() => {
                this.refreshCenterInfo(); // 清空
            }, duration);
        }
    }

    refresh() {
        this.resetFeedback();

        this.resetMouseInfo();

        this.resetCenterInfo();

        this._feedbackController.refresh();

        this.refreshSnapActor();
    }

    onClick(mouseEvent) {
        this.checkEnabled();

        this._mouseEvent = mouseEvent;
    }

    onDblclick(mouseEvent) {
        this.checkEnabled();

        this._mouseEvent = mouseEvent;
    }

    onMouseDown(mouseEvent) {
        this.checkEnabled();

        this._mouseEvent = mouseEvent;
    }

    onMouseMove(mouseEvent) {
        this.checkEnabled();

        this._mouseEvent = mouseEvent;
    }

    onMouseUp(mouseEvent) {
        this.checkEnabled();

        this._mouseEvent = mouseEvent;
    }

    onKeyPress(keyboardEvent) {
        this.checkEnabled();

        this._keyboardEvent = keyboardEvent;
    }

    onKeyDown(keyboardEvent) {
        this.checkEnabled();

        this._keyboardEvent = keyboardEvent;
    }

    onKeyUp(keyboardEvent) {
        this.checkEnabled();

        this._keyboardEvent = keyboardEvent;
    }

    onContextMenu(mouseEvent) {
        this.checkEnabled();

        this._mouseEvent = mouseEvent;
    }

    getMouseGeo() {
        return {
            type: 'Point',
            coordinates: [
                this._mouseEvent.latlng.lng,
                this._mouseEvent.latlng.lat
            ]
        };
    }
}
